// removed by extract-text-webpack-plugin
module.exports = {"container":"App__container___1yXLn","sticky-footer-toast":"App__sticky-footer-toast___25z4D"};